import { GenericServiceResponse } from './generic-service-response';
import { ResponseResultTypeDecorator } from './decorators/response-result-type.decorator';
import { LayoutMetaData } from '../layout-meta-data/layout-meta-data';

@ResponseResultTypeDecorator(LayoutMetaData)
export class LayoutMetaDataResponse extends GenericServiceResponse<LayoutMetaData> {

}
